import trackStateStore from "@/stores/clipEditor/trackState";
import { getGridPixel } from "@/utils/canvasUtil";

export default function useDragTrack() {
  function onMouseDown(event: any) {
    // 获取拖拽元素
    trackStateStore.dragElement = (event.target as HTMLElement).closest(
      ".trackItem"
    ) as HTMLElement;
    if (!trackStateStore.dragElement) {
      return;
    }

    trackStateStore.dragData.moveX = 0;
    trackStateStore.dragData.moveY = 0;

    const lineIndex = Number(trackStateStore.dragElement.dataset.line);
    const index = Number(trackStateStore.dragElement.dataset.index);
    // 获取当前鼠标位置
    trackStateStore.dragData.dragPoint.x = event.pageX;
    trackStateStore.dragData.dragPoint.y = event.pageY;
    // 设置拖拽信息
    trackStateStore.dragData.dataInfo =
      trackStateStore.trackList[lineIndex].list[index];
    trackStateStore.dragData.dragType =
      trackStateStore.dragElement.dataset.type;
    // 设置移动轨道信息
    trackStateStore.moveTrackData.lineIndex = lineIndex;
    trackStateStore.moveTrackData.itemIndex = index;
    // 重置当前选中的轨道
    trackStateStore.selectTrackItem.line = -1;
    trackStateStore.selectTrackItem.index = 0;
    const dragItem = trackStateStore.trackList[lineIndex].list[index];
    trackStateStore.curCoord = {
      start: dragItem.start,
      end: dragItem.end,
      left: getGridPixel(trackStateStore.trackScale, dragItem.start),
      right: getGridPixel(trackStateStore.trackScale, dragItem.end),
    };
    // 获取非当前位置的trackItem元素的left、right值
    trackStateStore.otherCoord = [];
    for (let i = 0; i < trackStateStore.trackList.length; i++) {
      for (let j = 0; j < trackStateStore.trackList[i].list.length; j++) {
        if (i !== lineIndex || j !== index) {
          const item = trackStateStore.trackList[i].list[j];
          trackStateStore.otherCoord.push({
            start: item.start,
            end: item.end,
            left: getGridPixel(trackStateStore.trackScale, item.start),
            right: getGridPixel(trackStateStore.trackScale, item.end),
          });
        }
      }
    }
  }

  function onMouseMove(event: any) {
    if (trackStateStore.dragElement) {
      if (trackStateStore.dragElement.dataset.type === "video") return;

      const moveX = event.pageX - trackStateStore.dragData.dragPoint.x;
      const moveY = event.pageY - trackStateStore.dragData.dragPoint.y;

      trackStateStore.setDragData({
        moveX,
        moveY,
      });

      const left = moveX + trackStateStore.curCoord.left;
      const right = moveX + trackStateStore.curCoord.right;
      const fixLines = [
        trackStateStore.getFixLine(left),
        trackStateStore.getFixLine(right),
      ];
      trackStateStore.setDragData({
        fixLines,
      });
      // 设置吸附
      trackStateStore.adsorption(
        { left, right },
        trackStateStore.dragData.fixLines
      );

      const info = trackStateStore.getInsertInfo();
      console.log("insertInfo================", info);
      trackStateStore.insert(info);
    }
  }

  function onMouseUp(event: any) {
    if (trackStateStore.dragElement) {
      if (trackStateStore.dragElement.dataset.type === "video") return;

      trackStateStore.dragData.moveX =
        event.pageX - trackStateStore.dragData.dragPoint.x;
      trackStateStore.dragData.moveY =
        event.pageY - trackStateStore.dragData.dragPoint.y;

      const left =
        trackStateStore.dragData.moveX + trackStateStore.curCoord.left;
      const right =
        trackStateStore.dragData.moveX + trackStateStore.curCoord.right;

      // trackStateStore.dragData.fixLines = [trackStateStore.getFixLine(left), trackStateStore.getFixLine(right)];
      //   console.log("xxxxxxxxxxxxxxxxxx", [
      //     trackStateStore.getFixLine(left),
      //     trackStateStore.getFixLine(right),
      //   ]);

      trackStateStore.setDragData({
        fixLines: [
          trackStateStore.getFixLine(left),
          trackStateStore.getFixLine(right),
        ],
      });

      // 设置吸附
      trackStateStore.adsorption(
        { left, right },
        trackStateStore.dragData.fixLines
      );
      const info = trackStateStore.getInsertInfo();
      console.log("up insertInfo================", info);

      // if (trackStateStore.dragData.dragType !== "video") {

      trackStateStore.insert(info);
      // }
      trackStateStore.dragElement = null;
    }
    // trackStateStore.dragData.fixLines = [];
    // // 重置移动轨道信息
    // trackStateStore.moveTrackData.lineIndex = -1;
    // trackStateStore.moveTrackData.itemIndex = -1;
    // trackStateStore.dragData.moveX = 0;
    // trackStateStore.dragData.moveY = 0;

    trackStateStore.setMoveTrackData({
      lineIndex: -1,
      itemIndex: -1,
    });

    trackStateStore.setDragData({
      fixLines: [],
      moveX: 0,
      moveY: 0,
    });

    trackStateStore.setInsertInfo({
      insertIndex: -1,
      itemIndex: -1,
      left: 0,
      right: 0,
      isNewLine: false,
      start: 0,
      end: 0,
    });
  }

  return {
    onMouseDown,
    onMouseMove,
    onMouseUp,
  };
}
